import { useState } from 'react';
import { ForgotPasswordForm } from '../components/forms/ForgotPassword/ForgotPasswordForm';
import { AuthBackgroundLayout } from '../layout/AuthBackgroundLayout';
import { TextButton } from '../components/ui/Button/Buttons';

export function ForgotPasswordPage() {
  const [isSent, setIsSent] = useState(false);
  const [email, setEmail] = useState('');

  return (
    <div className="h-screen flex items-center justify-center">
      <AuthBackgroundLayout>
        {isSent ? (
          <>
            <p className="text-2xl text-purple-900 font-bold self-stretch text-left">
              Please Check Your Email
            </p>
            <p className="text-base font-normal text-gray-950 text-left self-stretch">
              We sent reset password link to{' '}
              <span className="font-semibold break-words">{email}</span>
            </p>
            <div className="flex flex-row items-center text-sm text-gray-950">
              <p>Didn't receive the email?</p>
              <TextButton className="underline-custom px-1.5 py-0">
                Click to Resend
              </TextButton>
            </div>
          </>
        ) : (
          <>
            <p className="text-2xl text-purple-900 font-bold self-stretch text-left">
              Forgot Password?
            </p>
            <p className="text-base font-normal text-gray-950 text-left self-stretch">
              Please enter your email to reset password
            </p>
            <ForgotPasswordForm
              setIsSent={setIsSent}
              email={email}
              setEmail={setEmail}
            />
          </>
        )}
      </AuthBackgroundLayout>
    </div>
  );
}
